import classNames from 'classnames';
import createMarkup from 'helpers/createMarkup';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faBan, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import ImagenPerfil from '../../components/common/ImagenPerfil';

const Notification = ({
    flush,
    notification,
    setIdLead,
    setShowModalSeguimientoLead,
    hayNotificacionesNoLeidas
    //setIsModalOpen
}) => {
    const { token } = useToken();
    const navigate = useNavigate();

    let objAction = {};
    try {
        objAction = notification?.vJsonAction ? JSON.parse(notification.vJsonAction) : {};
    } catch {
        objAction = {};
    }

    const cuerpoRaw = notification?.vCuerpo || '';
    const cuerpoLower = cuerpoRaw.toLowerCase();
    const tituloLower = (notification?.vTitulo || '').toLowerCase();
    const actionTipo = (objAction?.tipoCancelacion || '').toUpperCase();

    // Detección de notificación en proceso de cancelación (programada)
    const isCancelacionProgramada =
        actionTipo === 'PROGRAMADA' ||
        tituloLower.includes('cancelación programada') ||
        tituloLower.includes('cancelacion programada') ||
        cuerpoLower.includes('programó la cancelación') ||
        cuerpoLower.includes('programo la cancelacion') ||
        cuerpoLower.includes('cancelación programada') ||
        cuerpoLower.includes('cancelacion programada');

    // Detección de notificación cancelada por completo (definitiva/finalizada)
    const isCancelacionCompleta =
        !isCancelacionProgramada && (
            actionTipo === 'DEFINITIVA' ||
            tituloLower.includes('cancelación de suscripción') ||
            tituloLower.includes('cancelacion de suscripcion') ||
            cuerpoLower.includes('se canceló la suscripción') ||
            cuerpoLower.includes('se cancelo la suscripcion') ||
            cuerpoLower.includes('se canceló por completo') ||
            cuerpoLower.includes('se cancelo por completo') ||
            cuerpoLower.includes('concluyó su período pagado') ||
            cuerpoLower.includes('concluyo su periodo pagado')
        );

    // Ocultar cualquier texto "Motivo: ..." y simplificar texto de cancelación ("del cliente" está de más)
    let cleanCuerpo = cuerpoRaw.replace(/\.?\s*Motivo\s*:\s*[^<.]*(?=<|$|\.)/gi, '');
    if (isCancelacionProgramada || isCancelacionCompleta) {
        cleanCuerpo = cleanCuerpo
            .replace(/\s+por\s+completo/gi, '')
            .replace(/\s+del\s+cliente(?:\s*<[^>]+>[^<]*<\/[^>]+>)?(?:\s*#?\d+)?\s*\.?/gi, '.');
    }

    // Maneja el click para abrir el modal de seguimiento de lead
    const clickToModalSeguimientoLead = (idLead) => {
        setIdLead(idLead);
        setShowModalSeguimientoLead(true);
        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);
    };

    const clickToUrl = () => {
        notification.bFueMostrado = true;
        marcarNotificacionComoMostrada(notification.idNotificacion);
        if (objAction?.detalles?.vUrl) {
            navigate(objAction.detalles.vUrl);
        }
    };

    const marcarNotificacionComoMostrada = async (idNotificacion) => {
        var jDataSend = {};
        jDataSend.idNotificacion = idNotificacion;

        const response = await fetch("/api/account/MarcarNotificacionComoMostrada/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response && response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1 && hayNotificacionesNoLeidas) {
                hayNotificacionesNoLeidas();
            }
        }
    };

    const handleClick = () => {
        if (objAction.TypeAction == 1) {
            if (objAction.detalles?.idModalType == 1) {
                if (objAction.detalles?.data?.idLicense) {
                    notification.bFueMostrado = true;
                    marcarNotificacionComoMostrada(notification.idNotificacion);
                    navigate(`/licencias/detalle/${objAction.detalles.data.idLicense}`);
                } else if (objAction.detalles?.data?.idLead) {
                    clickToModalSeguimientoLead(objAction.detalles.data.idLead);
                }
            }
        }
        if (objAction.TypeAction == 2 || objAction.TypeAction == 3) {
            clickToUrl();
        }
    };

    // Estilos de tarjeta con acento de color característico
    let itemStyle = { border: 'none', cursor: 'pointer', transition: 'all 0.15s ease' };
    if (isCancelacionProgramada) {
        itemStyle = {
            ...itemStyle,
            borderLeft: '4px solid #f59e0b',
            backgroundColor: notification.bFueMostrado ? '#fffdf7' : '#fffbeb'
        };
    } else if (isCancelacionCompleta) {
        itemStyle = {
            ...itemStyle,
            borderLeft: '4px solid #ef4444',
            backgroundColor: notification.bFueMostrado ? '#fffafa' : '#fef2f2'
        };
    }

    return (
        <div
            className={classNames(
                'notification',
                (isCancelacionProgramada || isCancelacionCompleta) ? 'px-3 py-2' : 'p-2',
                {
                    'notification-unread': !notification.bFueMostrado && !isCancelacionProgramada && !isCancelacionCompleta,
                    'notification-flush': flush
                }
            )}
            style={itemStyle}
            onClick={handleClick}
        >
            <div className="notification-avatar me-2 justify-items-center">
                {isCancelacionProgramada ? (
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                        style={{
                            width: '32px',
                            height: '32px',
                            minWidth: '32px',
                            backgroundColor: '#fef3c7',
                            color: '#d97706',
                            border: '1px solid #fde68a'
                        }}
                    >
                        <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: '0.95rem' }} />
                    </div>
                ) : isCancelacionCompleta ? (
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                        style={{
                            width: '32px',
                            height: '32px',
                            minWidth: '32px',
                            backgroundColor: '#fee2e2',
                            color: '#dc2626',
                            border: '1px solid #fecaca'
                        }}
                    >
                        <FontAwesomeIcon icon={faBan} style={{ fontSize: '0.95rem' }} />
                    </div>
                ) : (
                    <ImagenPerfil idUsuario={notification.idUsuarioSource} />
                )}
            </div>

            <div className="notification-body flex-grow-1">
                {isCancelacionProgramada && (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span
                            className="badge"
                            style={{
                                backgroundColor: '#fef3c7',
                                color: '#92400e',
                                border: '1px solid #fde68a',
                                fontSize: '10px',
                                fontWeight: 700,
                                letterSpacing: '0.3px',
                                textTransform: 'uppercase',
                                padding: '2px 7px',
                                borderRadius: '4px'
                            }}
                        >
                            <FontAwesomeIcon icon={faClock} className="me-1" />
                            Cancelación Programada
                        </span>
                        <span
                            style={{
                                width: '7px',
                                height: '7px',
                                borderRadius: '50%',
                                backgroundColor: '#f59e0b',
                                display: 'inline-block'
                            }}
                            title="Cancelación en proceso"
                        />
                    </div>
                )}

                {isCancelacionCompleta && (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span
                            className="badge"
                            style={{
                                backgroundColor: '#fee2e2',
                                color: '#991b1b',
                                border: '1px solid #fecaca',
                                fontSize: '10px',
                                fontWeight: 700,
                                letterSpacing: '0.3px',
                                textTransform: 'uppercase',
                                padding: '2px 7px',
                                borderRadius: '4px'
                            }}
                        >
                            <FontAwesomeIcon icon={faBan} className="me-1" />
                            Suscripción Cancelada
                        </span>
                        <span
                            style={{
                                width: '7px',
                                height: '7px',
                                borderRadius: '50%',
                                backgroundColor: '#ef4444',
                                display: 'inline-block'
                            }}
                            title="Cancelada definitivamente"
                        />
                    </div>
                )}

                <p className="mb-1 text-dark" style={{ fontSize: '0.82rem', lineHeight: '1.25' }} dangerouslySetInnerHTML={createMarkup(cleanCuerpo)} />
                <span className="notification-time text-muted" style={{ fontSize: '0.72rem' }}>
                    {notification.time}
                </span>
            </div>
        </div>
    );
};

Notification.propTypes = {
    flush: PropTypes.bool,
    notification: PropTypes.object,
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
    hayNotificacionesNoLeidas: PropTypes.func
    //setIsModalOpen: PropTypes.func,
};

export default Notification;
